import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=cc5ade5e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=cc5ade5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5ade5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc5ade5e')) {
      api.createRecord('cc5ade5e', component.options)
    } else {
      api.reload('cc5ade5e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=cc5ade5e&scoped=true&", function () {
      api.rerender('cc5ade5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4seL8oHqL3Odi/JS/comp/GuestBox.vue"
export default component.exports